export default __webpack_public_path__ + "static/media/mTop_3_c3.b25b0128.jpeg";